module.exports = __webpack_public_path__ + "static/media/Logo.7d742e31.svg";